import axios from 'axios';
import { Message } from 'element-ui';
import router from '../router';
// http response 拦截器
// let Beitoken = localStorage.getItem("Beitoken")
axios.interceptors.response.use(res => {
        // if(res.request.responseURL.indexOf('https://orders1.xinfushenghuo.cn/api/CallBack/QueryOrderDetailInfo')!==-1){
        //     res.headers.common['Authorization'] = Beitoken?'Bearer '+Beitoken:'';
        // }
        if (res.data.code == 2) {
            Message({
                type: 'warning',
                message: 'token失效，请重新登入'
            });
            router.replace({ path: '/login' })
        }
        
        return res;
    }, err => {
        if (err.response) {
            switch (err.response.status) {
                case 401:
                    // localStorage.clear(); // 请求前先清除所有信息
                    // localStorage.setItem('activeUrl',window.location.herf);  
                    //跳转到鉴权页面
                    // router.push({
                    //   path: '/auth'
                    // });
                    break;
                case 404:
                    Message({
                        type: 'error',
                        message: err.response.statusText
                    });
                    //跳转到404页面
                    router.replace({
                        path: '/404'
                    });

                    break;
                case 500:
                    Message({
                        type: 'error',
                        message: err.response.statusText
                    });
                    //跳转到500页面
                    router.replace({
                        path: '/500'
                    });
                    break;
            }
        }
        return Promise.reject(err);
    }
);

export default axios;